import { ref, watch, computed } from "@vue/composition-api";
import store from "@/store";
import reFetchAPI from "@/utils/refetch-api";
import { errorNotification } from "@/utils/toast-notifications";

export default function useLivenessCheckList() {
  const refLivenessCheckListTable = ref(null);

  // Table Handlers
  const tableColumns = [
    { key: "driverId", label: "External ID" },
    { key: "dateTime", label: "Date & Time" },
    { key: "driverPhone", label: "Driver Phone Number" },
    { key: "status", label: "Status" },
    { key: "videoUrl", label: "Video URL" },
  ];
  const perPage = ref(10);
  const totalLivenessChecks = ref(0);
  const currentPage = ref(1);
  const perPageOptions = [10, 25, 50];
  const searchQuery = ref({
    driverId: "",
    startDate: "",
    driverPhone: "",
  });
  const loadingLivenessChecks = ref(false);
  const livenessChecks = ref([]);

  const fetchLivenessChecks = async () => {
    if (loadingLivenessChecks.value) return;

    loadingLivenessChecks.value = true;
    const requestSearchQuery = { ...searchQuery.value };

    // Clean up empty search parameters
    Object.keys(requestSearchQuery).forEach((key) => {
      if (
        !requestSearchQuery[key] ||
        requestSearchQuery[key] === "" ||
        requestSearchQuery[key] === null
      ) {
        delete requestSearchQuery[key];
      }
    });

    try {
      const response = await store.dispatch(
        "livenessCheck/fetchLivenessChecks",
        {
          ...requestSearchQuery,
          page: currentPage.value,
          perPage: perPage.value,
        }
      );

      loadingLivenessChecks.value = false;
      livenessChecks.value = response.data || [];
      totalLivenessChecks.value = response.total || 0;
    } catch (error) {
      loadingLivenessChecks.value = false;
      console.error("Error fetching liveness checks:", error);
      if (error.message && error.message.includes("timeout")) {
        fetchLivenessChecks();
      } else {
        reFetchAPI(fetchLivenessChecks);
        errorNotification("Something went wrong!!, retrying..");
      }
    }
  };

  watch([currentPage, perPage], () => {
    fetchLivenessChecks();
  });

  // Status variant helper
  const getStatusVariant = (status) => {
    const statusMap = {
      VALID: "success",
      EXPIRED: "danger",
      PROCESSING: "warning",
    };
    return statusMap[status] || "secondary";
  };

  return {
    fetchLivenessChecks,
    livenessChecks,
    tableColumns,
    perPage,
    currentPage,
    totalLivenessChecks,
    perPageOptions,
    searchQuery,
    refLivenessCheckListTable,
    loadingLivenessChecks,
    getStatusVariant,
  };
}
